"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _deliveryDetailsSlice = require("../../redux/deliveryDetailsSlice");
var _giftSlice = require("../../redux/giftSlice");
var _popupSlice = require("../../redux/popupSlice");
var _store = require("../../redux/store");
var _Button = _interopRequireDefault(require("../Button"));
var _InnerPopupWrapper = _interopRequireDefault(require("../InnerPopupWrapper"));
var _RecipientForm = _interopRequireDefault(require("../DeliveryDetails/RecipientForm"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _validators = require("../DeliveryDetails/RecipientForm/validators");
var _SkeletonWrapper = _interopRequireDefault(require("../SkeletonWrapper"));
var _EditDeliveryDetailsPopupStyled = require("./EditDeliveryDetailsPopupStyled");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var CheckmarkIcon = function CheckmarkIcon(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        fill: "red",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    fill: "#bcc3cd",
                    d: "M93.648 5.464h-1.572a.762.762 0 0 1-.762-.762.762.762 0 0 1 .762-.762h1.572a.762.762 0 0 1 .762.762.762.762 0 0 1-.762.762z"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    fill: "#bcc3cd",
                    d: "M99.956 5.464h-1.572a.762.762 0 0 1-.762-.762.762.762 0 0 1 .762-.762h1.572a.762.762 0 0 1 .762.762.762.762 0 0 1-.762.762z"
                  })
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    fill: "#bcc3cd",
                    d: "M96.016 3.096a.761.761 0 0 1-.762-.762V.762A.761.761 0 0 1 96.016 0a.762.762 0 0 1 .762.762v1.572a.762.762 0 0 1-.762.762z"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    fill: "#bcc3cd",
                    d: "M96.016 9.405a.761.761 0 0 1-.762-.762V7.07a.761.761 0 0 1 .762-.762.762.762 0 0 1 .762.762v1.572a.762.762 0 0 1-.762.762z"
                  })
                })]
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    fill: "#bcc3cd",
                    d: "m4.437 65.45-1.111-1.112a.762.762 0 0 1 0-1.078.762.762 0 0 1 1.077 0l1.112 1.112a.762.762 0 0 1 0 1.078.762.762 0 0 1-1.078 0z"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    fill: "#bcc3cd",
                    d: "m8.898 69.91-1.112-1.112a.762.762 0 0 1 0-1.077.762.762 0 0 1 1.078 0l1.111 1.111a.762.762 0 0 1 0 1.078.762.762 0 0 1-1.077 0z"
                  })
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    fill: "#bcc3cd",
                    d: "M7.784 65.45a.762.762 0 0 1 0-1.077l1.111-1.112a.762.762 0 0 1 1.078 0 .762.762 0 0 1 0 1.078L8.861 65.45a.762.762 0 0 1-1.077 0z"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    fill: "#bcc3cd",
                    d: "M3.323 69.91a.762.762 0 0 1 0-1.077l1.112-1.112a.762.762 0 0 1 1.078 0 .762.762 0 0 1 0 1.078L4.4 69.911a.762.762 0 0 1-1.078 0z"
                  })
                })]
              })]
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            stroke: "#838eaa",
            fill: "none",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
              r: "3",
              cy: "8.838",
              cx: "9.471"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
              r: "2.5",
              cy: "8.838",
              cx: "9.471"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            stroke: "#838eaa",
            fill: "none",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
              r: "3",
              cy: "62.838",
              cx: "96.471"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
              r: "2.5",
              cy: "62.838",
              cx: "96.471"
            })]
          })]
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fill: "#4eb7a1",
            d: "M71.684 20.127a1.733 1.733 0 0 0-2.451 0l-20.8 20.743-7.5-8.15a1.734 1.734 0 1 0-2.551 2.349l8.726 9.477a1.732 1.732 0 0 0 1.238.559h.037a1.735 1.735 0 0 0 1.224-.506l22.075-22.018a1.733 1.733 0 0 0 .002-2.454z"
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fill: "#4eb7a1",
            d: "M71.266 35.104a1.734 1.734 0 0 0-1.733 1.734A19.533 19.533 0 1 1 50 17.305a1.734 1.734 0 1 0 0-3.467 23 23 0 1 0 23 23 1.734 1.734 0 0 0-1.734-1.734z"
          })
        })
      })]
    })]
  });
};
CheckmarkIcon.defaultProps = {
  width: "100.718",
  height: "73.237",
  xmlns: "http://www.w3.org/2000/svg",
  color: "red"
};
var WarningIcon = function WarningIcon(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                        d: "M93.648 5.464h-1.572a.762.762 0 0 1-.762-.762.762.762 0 0 1 .762-.762h1.572a.762.762 0 0 1 .762.762.762.762 0 0 1-.762.762Z",
                        fill: "#cb4477"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                        d: "M99.956 5.464h-1.572a.762.762 0 0 1-.762-.762.762.762 0 0 1 .762-.762h1.572a.762.762 0 0 1 .762.762.762.762 0 0 1-.762.762Z",
                        fill: "#cb4477"
                      })
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                        d: "M96.016 3.096a.761.761 0 0 1-.762-.762V.762A.761.761 0 0 1 96.016 0a.762.762 0 0 1 .762.762v1.572a.762.762 0 0 1-.762.762Z",
                        fill: "#cb4477"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                        d: "M96.016 9.405a.761.761 0 0 1-.762-.762V7.071a.761.761 0 0 1 .762-.762.762.762 0 0 1 .762.762v1.572a.762.762 0 0 1-.762.762Z",
                        fill: "#cb4477"
                      })
                    })]
                  })]
                }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                        d: "m4.437 65.45-1.111-1.112a.762.762 0 0 1 0-1.078.762.762 0 0 1 1.077 0l1.112 1.112a.762.762 0 0 1 0 1.078.762.762 0 0 1-1.078 0Z",
                        fill: "#cb4477"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                        d: "m8.898 69.91-1.112-1.112a.762.762 0 0 1 0-1.077.762.762 0 0 1 1.078 0l1.111 1.111a.762.762 0 0 1 0 1.078.762.762 0 0 1-1.077 0Z",
                        fill: "#cb4477"
                      })
                    })]
                  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                        d: "M7.784 65.45a.762.762 0 0 1 0-1.077l1.111-1.112a.762.762 0 0 1 1.078 0 .762.762 0 0 1 0 1.078L8.862 65.45a.762.762 0 0 1-1.078 0Z",
                        fill: "#cb4477"
                      })
                    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                        d: "M3.323 69.91a.762.762 0 0 1 0-1.077l1.112-1.111a.762.762 0 0 1 1.078 0 .762.762 0 0 1 0 1.077L4.4 69.911a.762.762 0 0 1-1.078 0Z",
                        fill: "#cb4477"
                      })
                    })]
                  })]
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                fill: "none",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M9.471 5.838a3 3 0 1 1-3 3 3 3 0 0 1 3-3Z"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M9.471 6.838c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m0-1a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z",
                  fill: "#cb4477"
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                fill: "none",
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M96.471 59.838a3 3 0 1 1-3 3 3 3 0 0 1 3-3Z"
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                  d: "M96.471 60.838c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2m0-1a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z",
                  fill: "#cb4477"
                })]
              })]
            })
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          transform: "translate(31 11.838)",
          fill: "#cb4477",
          stroke: "#cb4477",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M44.767 35.584c-3.008-6.169-8.049-14.92-12.5-22.64-2.327-4.041-4.526-7.856-6.115-10.756a4 4 0 0 0-7.129 0c-1.59 2.9-3.79 6.721-6.12 10.764C8.458 20.667 3.418 29.417.412 35.584A4.012 4.012 0 0 0 0 37.35a4.054 4.054 0 0 0 4.035 4.064h37.108a4.054 4.054 0 0 0 4.035-4.064 4.011 4.011 0 0 0-.411-1.766Zm-3.623 3.948H4.037a2.171 2.171 0 0 1-2.153-2.182 2.14 2.14 0 0 1 .221-.941c2.978-6.109 8-14.826 12.431-22.517 2.335-4.053 4.54-7.881 6.139-10.8a2.18 2.18 0 0 1 3.827 0c1.6 2.917 3.8 6.742 6.135 10.791 4.433 7.693 9.457 16.414 12.436 22.525a2.135 2.135 0 0 1 .222.942 2.171 2.171 0 0 1-2.151 2.182Z"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            d: "M22.589 9.413a.941.941 0 0 0-.941.941v18.824a.941.941 0 1 0 1.883 0V10.354a.941.941 0 0 0-.942-.941Z"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
            cx: ".941",
            cy: ".941",
            r: ".941",
            transform: "translate(21.648 33.884)"
          })]
        })
      })]
    })
  });
};
WarningIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "100.718",
  height: "73.237"
};
const EditDeliveryDetailsPopup = () => {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const dispatch = (0, _store.useAppDispatch)();
  const [currentStep, setCurrentStep] = (0, _react.useState)(1);
  const [error, setError] = (0, _react.useState)(false);
  const {
    recipientEmail,
    deliveryDate,
    deliveryTime,
    message
  } = (0, _store.useAppSelector)(_deliveryDetailsSlice.selectDeliveryDetails);
  const {
    giftId,
    offerId,
    offerTitle
  } = (0, _store.useAppSelector)(_popupSlice.selectEditDeliveryDetailsPopup);
  const {
    gift: {
      deliveryDetails: giftDeliveryDetails,
      redeemedAt,
      sentAt
    },
    isUpdateLoading,
    loading
  } = (0, _store.useAppSelector)(_giftSlice.selectGift);
  const updateGift = async () => {
    const areDeliveryDetailsValid = (0, _validators.validateDeliveryDetailsForm)();
    if (areDeliveryDetailsValid) {
      await dispatch((0, _giftSlice.fetchUpdateGift)({
        id: giftId,
        payload: {
          deliveryDetails: {
            recipientEmail: recipientEmail.value,
            deliveryDate: new Date("".concat(deliveryDate.value, "T").concat(deliveryTime.value)).valueOf() / 1000,
            personalNote: message.value
          }
        }
      })).unwrap().catch(() => {
        setError(true);
      });
      setCurrentStep(2);
    }
  };
  (0, _react.useEffect)(() => {
    if (giftId) {
      dispatch((0, _giftSlice.fetchGift)(giftId));
    }
    return () => {
      dispatch((0, _popupSlice.hidePopup)());
      dispatch((0, _deliveryDetailsSlice.resetDeliveryDetailsState)());
    };
  }, [giftId]);
  const isGiftEditable = (0, _validators.isDateInFuture)(new Date((giftDeliveryDetails === null || giftDeliveryDetails === void 0 ? void 0 : giftDeliveryDetails.deliveryDate) * 1000)) && !sentAt && !redeemedAt;
  const isGiftSent = !!sentAt || !!redeemedAt;
  if (loading) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapper.default, {
      steps: 2,
      isError: false,
      currentStep: 1,
      popupTitle: t('edit-delivery-details-popup.title', 'Edit Delivery Details'),
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_EditDeliveryDetailsPopupStyled.ContentStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_EditDeliveryDetailsPopupStyled.HeaderStyled, {
          children: t('edit-delivery-details-popup.header', 'Edit Delivery Details')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditDeliveryDetailsPopupStyled.InfoTextSkeletonStyled, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
            height: 32,
            margin: "0 0 24px 0"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_RecipientForm.default, {
          isMyAccount: true
        })]
      })
    });
  }
  if (currentStep === 1) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapper.default, {
      steps: 2,
      isError: false,
      currentStep: currentStep,
      popupTitle: t('edit-delivery-details-popup.title', 'Edit Delivery Details'),
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_EditDeliveryDetailsPopupStyled.ContentStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_EditDeliveryDetailsPopupStyled.HeaderStyled, {
          children: t('edit-delivery-details-popup.header', 'Edit Delivery Details')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditDeliveryDetailsPopupStyled.InfoTextStyled, {
          children: isGiftEditable ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [t('edit-delivery-details-popup.info-text-1', 'You are editing information for your'), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              children: t("offer-title-".concat(offerId), offerTitle)
            }), t('edit-delivery-details-popup.info-text-2', 'Please take a moment to update your gift delivery details.')]
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
            children: isGiftSent ? t('edit-delivery-details-popup.info-text-disabled', 'It is not possible to edit delivery details as the gift has been already sent out to the recipient.') : t('edit-delivery-details-popup.info-text-disabled2', 'It is not possible to edit delivery details as the gift will be sent to the recipient soon.')
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_RecipientForm.default, {
          isMyAccount: true
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditDeliveryDetailsPopupStyled.ButtonsStyled, {
          children: isGiftEditable ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
              theme: "simple",
              onClickFn: () => dispatch((0, _popupSlice.hidePopup)()),
              children: t('edit-delivery-details-popup.button.cancel', 'Back')
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
              theme: "confirm",
              onClickFn: updateGift,
              children: isUpdateLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
                buttonLoader: true,
                color: "#ffffff"
              }) : t('edit-delivery-details-popup.button.confirm', 'Update details')
            })]
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
            theme: "confirm",
            onClickFn: () => dispatch((0, _popupSlice.hidePopup)()),
            children: t('edit-delivery-details-popup.button.back', 'Back to settings')
          })
        })]
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapper.default, {
    steps: 2,
    isError: false,
    currentStep: currentStep,
    popupTitle: t('edit-delivery-details-popup.title', 'Edit Delivery Details'),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditDeliveryDetailsPopupStyled.ContentStyled, {
      children: error ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_EditDeliveryDetailsPopupStyled.ErrorPageStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(WarningIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditDeliveryDetailsPopupStyled.HeaderStyled, {
          children: t('edit-delivery-details-popup.thank-you-page.error-header', 'Failed to update the delivery details')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditDeliveryDetailsPopupStyled.ErrorTextStyled, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
            children: t('edit-delivery-details-popup.thank-you-page.error-text-1', "We weren't able to process your request.")
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditDeliveryDetailsPopupStyled.ErrorTextStyled, {
          children: t('edit-delivery-details-popup.thank-you-page.error-text-2', 'Please try updating the delivery details again in a few minutes.')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          theme: "confirm",
          onClickFn: () => dispatch((0, _popupSlice.hidePopup)()),
          children: t('edit-delivery-details-popup.button.back', 'Back to settings')
        })]
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_EditDeliveryDetailsPopupStyled.ThankYouPageStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(CheckmarkIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditDeliveryDetailsPopupStyled.HeaderStyled, {
          children: t('edit-delivery-details-popup.thank-you-page.header', 'Delivery Details Updated')
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_EditDeliveryDetailsPopupStyled.InfoTextStyled, {
          children: [t('edit-delivery-details-popup.thank-you-page.info-text-1', 'Thank you for updating your delivery details for your'), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            children: t("offer-title-".concat(offerId), offerTitle)
          }), t('edit-delivery-details-popup.thank-you-page.info-text-2', 'Your changes have been saved and will be reflected in your next delivery.')]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          theme: "confirm",
          onClickFn: () => dispatch((0, _popupSlice.hidePopup)()),
          children: t('edit-delivery-details-popup.button.back', 'Back to settings')
        })]
      })
    })
  });
};
var _default = exports.default = EditDeliveryDetailsPopup;